import axios from 'axios'
import qs from 'qs'
import 'babel-polyfill'
let hosts = require('./host-config.js')
const digitsRE = /(\d{3})(?=\d)/g
import { Message } from 'element-ui';
function rap (urlList) {
  let obj = {}
  for (var key in urlList) {
    if (urlList.hasOwnProperty(key)) {
      obj[key] = hosts.host + urlList[key]
    }
  }
  return obj
}

// 获取url的指定参数值
function getUrlParam (key) {
  var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
  var r = location.search.substr(1).match(reg)
  if (r) {
    return decodeURI(r[2])
  }
  return ''
}

// 获取url的所有参数值
function getUrlParams () {
  let arr = location.search.substr(1).split('&')
  let arr2 = location.hash.slice(location.hash.search(/\?/) + 1).split('&')
  let obj = {}
  arr.concat(arr2).forEach(function (o, i) {
    let temp = o.split('=')
    if (temp[1]) obj[temp[0]] = decodeURI(temp[1])
  })
  return obj
}

// 获取hash的参数值
function getHashParms () {
  let arr = location.hash.slice(location.hash.search(/\?/) + 1).split('&')
  let obj = {}
  arr.forEach(function (o, i) {
    let temp = o.split('=')
    if (temp[1]) obj[temp[0]] = decodeURI(temp[1])
  })
  return obj
}

// 验证手机
function checkphone (phone) {
  let rule = /^1[3,4,5,7,8,9]\d{9}$/
  if (rule.test(phone)) {
    return true
  }
  return false
}

/**
 * 异步获取后台数据
 * @param {string} url 请求的url地址
 * @param {Object} data 请求的参数对象,默认值为undefined
 * @return {Promise} 返回一个promise对象
 */
function fetch (url, data = undefined) {
  let formData = null
  window.requestTokens = window.requestTokens || {}
  if (data) {
    formData = Object.keys(data)
    formData.forEach(item => {
      if (typeof data[item] === 'object') {
        data[item] = JSON.stringify(data[item])
      }
    })
  }
  // if(window.requestTokens[url]){ // 如果当前url存在还没有完成的请求
  //   window.requestTokens[url].cancel('取消旧请求，创建新请求.');
  // }
  // const CancelToken = axios.CancelToken;
  // const source = CancelToken.source();
  // window.requestTokens[url] = source;

  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(data),{
      // cancelToken: source.token
    }).then((response) => {
      let result = response.data
      // window.requestTokens[url] = undefined; // 请求完成之后移除请求缓存
      if ((result.status === 401) && url !== '/fep/pc/login') {
        Message.closeAll()
        Message.error(result.message)
        location.hash = '#/login'
      } else if (result.status === 403 && url !== '/fep/pc/login') {
        Message.closeAll()
        Message.error(result.message)
        reject(result)
      }
      if (result.status === 500) {
        Message.closeAll()
        Message.error(result.message)
        reject(result)
      } else if (result.status === 504) {
        Message.closeAll()
        console.log(504)
        Message.error('服务器响应超时，请稍后再试')
        reject(result)
      } else {
        resolve(result)
      }
    }).catch((error) => {
      console.log(error)
      // window.requestTokens[url] = undefined; // 请求完成之后移除请求缓存
      if (error.status === 504) {
        Message.closeAll()
        console.log(504)
        Message.error('服务器响应超时，请稍后再试')
      }
      reject({
        status: -1,
        message: error
      })
    })
  })
}

// cookie的set和get，方案来源：http://www.w3schools.com/js/js_cookies.asp
function setCookie (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
function removeCookie (name, path, domain) {
  setCookie(name, '', -1, path, domain)
}

/**
 * 分割数组
 * @param {list} 要分割的数组  [1,2,3,4,5,6,7]
 * @param {num} 每份分割的数量 3
 * @return {Array} 返回分割后的数组 [[1,2,3],[4,5,6],[7]]
 */
function spliceList (list, num) {
  list = list || []
  let tList = []
  let temp = []
  for (let i = 0; i < list.length; i++) {
    if (i % num !== 0 || i === 0) {
      temp.push(list[i])
    } else {
      tList.push(temp)
      temp = []
      temp.push(list[i])
    }
  }
  tList.push(temp)
  return tList
}
/**
 * 分割字符串成数组
 * @param {str} 要分割的字符串  “a;b;c;d;”
 * @param {separator} 分割符   ";"
 * @return {Array} 返回分割后的数组 [a,b,c,d]
 */
function strToList (str, separator) {
  return str.split(separator).filter(function (o, i) {
    return !!o
  })
}
/**
 * 设置手机号中间4位为星号
 * @param {phone} 要设置的手机号
 * @return {string} 返回 136****4525
 */
function setPhone (phone) {
  return phone.substr(0, 3) + '****' + phone.substr(7)
}
function setIdCard (idCard) {
  return idCard.substr(0, 5) + '******' + idCard.substr(11)
}
/**
 * 判断密码是否存在空格
 * @param {str} 验证的密码字符串”
 */
function checkPwdTrim (str) {
  let reg = /\s+/g
  return reg.test(str)
}

/**
 * 判断密码等级
 */
function AnalyzePasswordSecurityLevel (password) {
  var securityLevel = 0
  if (/[A-Za-z]/.test(password)) {
    securityLevel++ //lowercase
  }
  if (/[0-9]/.test(password)) {
    securityLevel++ //digital
  }
  if (containSpecialChar(password)) {
    securityLevel++ //specialcase
  }
  return securityLevel
}
/**
 * 是否含有特殊符号
 */
function containSpecialChar (str) {
  var containSpecial = RegExp(/[(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/)
  return (containSpecial.test(str))
}

/**
 * 验证身份证号格式
 */
function idCard (str) {
  let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(str)
}
/**
 * 验证邮箱
 */
function checkEmail (str) {
  let reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
  return reg.test(str)
}

// 日期格式化：2017-08-05
function dateFormat (formatDate) {
  console.log('~~~~~ dateFormat:', formatDate)
  // return ddd
  // let arr = formatDate.toLocaleDateString().split('/')
  // let newArr = arr.map(item => {
  //   if (parseInt(item) < 10) {
  //     return '0' + item
  //   }
  //   return item
  // })
  // console.log('date format ##########', newArr)
  // return newArr.join('-')
  return datetimeFormat('yyyy-MM-dd',formatDate)
}

// 日期格式化 yyyy-MM-dd hh:mm:ss
// @param {str} 'yyyy-MM-dd hh:mm:ss'
// @param {Date} new Date()
function datetimeFormat (fmt, date) {
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * 去除空格
 * @param  {[type]} str  传入的字符串
 * @param  {[type]} type  1-所有空格  2-前后空格  3-前空格  4-后空格
 * @return {[type]}      去除空格后的新字符串
 */
function trim (str, type) {
  switch (type) {
    case 1:
      return str.replace(/\s+/g, '')
    case 2:
      return str.replace(/(^\s*)|(\s*$)/g, '')
    case 3:
      return str.replace(/(^\s*)/g, '')
    case 4:
      return str.replace(/(\s*$)/g, '')
    default:
      return str
  }
}

/**
  * 12345 => $12,345.00
  * 金额过滤器
  * @param {String} sign
  * @param {Number} decimals Decimal places
 */
function currency (value, currency, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : '¥'
  decimals = decimals != null ? decimals : 2
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}

/**
 * 超出省略隐藏
 * @param str 需要截取的字符串
 * @param number 需要截取字符串的个数
 */
function omit (str, number) {
  if (str.length > number) {
    return str.substring(0, number) + '...'
  } else {
    return str
  }
}
/**
 * 大于万的格式化
 * @param {any} val
 * @returns
 */
function TenThousand (val) {
  return val > 10000 ? (val / 10000).toFixed(1) + '万' : val
}

function hasAuthority (name) {
  let reg = new RegExp(`(^|/)${name}([^/]*)(/|$)`)
  let content = localStorage.getItem('authCodeList')
  // console.log(name, reg.test(content))
  return reg.test(content)
}
// //百度统计
// (function () {
//   window._hmt = window._hmt || []
//   var hm = document.createElement('script')
//   hm.src = 'https://hm.baidu.com/hm.js?f38fc2204445bb70ef93a01825df12d6'
//   var s = document.getElementsByTagName('script')[0]
//   s.parentNode.insertBefore(hm, s)
// })()

const mapKey = '3dd316a8a800a1ce76a4d3c8e09b1e02'


/**
 * 定时器
*/
class Timer {
  constructor(total, delay = 1000) {
    this.total = total
    this.delay = delay
    this.num = total
    this.timer = null
  }
  run(cb = () => {}) {
    const {delay} = this
    console.log('xxx1', this.num)
    this.num = this.num - 1
    cb(this.num)
    console.log('xxx', this.num)
    if (this.num > 0) {
      this.timer = setTimeout(() => {
        this.run(cb)
      }, delay)
    } else {
      this.end()
    }
  }
  cancel() {
    const timer = this.timer
    timer && clearTimeout(timer)
  }
  end() {

  }
}

export {
  rap,
  mapKey,
  getUrlParam,
  getUrlParams,
  getHashParms,
  fetch,
  setCookie,
  getCookie,
  removeCookie,
  checkphone,
  spliceList,
  strToList,
  setPhone,
  setIdCard,
  checkPwdTrim,
  AnalyzePasswordSecurityLevel,
  idCard,
  checkEmail,
  dateFormat,
  datetimeFormat,
  trim,
  currency,
  omit,
  TenThousand,
  hasAuthority,
  Timer
}
